import { combineReducers, mergeReducers } from 'redux-merge-immutable-reducers';
import coreCustomer from '@synergycms_core/store/customer/customer';
import { currencies, current_currency } from '@synergycms_core/store/customer/currency';



export default mergeReducers(
  coreCustomer,
  combineReducers({ currencies, current_currency })
);